import omit from 'lodash.omit';
import {
  LOGIN_SUCCESS,
  UNSET_ACCOUNT,
  LOGOUT,
  GET_USER_KIND,
  SET_CS_ADMIN_ACCOUNTS,
} from '@app/actions/user';

const initialState = {
  isAuthenticated: false,
  customerServiceAdminAccounts: {},
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_CS_ADMIN_ACCOUNTS:
      return {
        ...state,
        customerServiceAdminAccounts: action.customerServiceAdminAccounts,
      };

    case GET_USER_KIND:
      return {
        ...state,
        kind: action.kind,
      };

    case LOGIN_SUCCESS:
      const { account, username, password } = action;
      return {
        ...state,
        account,
        username,
        password,
        isAuthenticated: true,
      };

    case UNSET_ACCOUNT:
      return omit(state, 'account');

    case LOGOUT:
      return {
        account: state.account,
        isAuthenticated: false,
      };

    default:
      return state;
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/reducer/user.js